import api from './api';
import { Erinnerung, ErinnerungRequest } from '../types';

export const erinnerungService = {
  getPending: async (): Promise<Erinnerung[]> => {
    const response = await api.get('/erinnerungen');
    return response.data;
  },

  getByKunde: async (kundeId: number): Promise<Erinnerung[]> =>
    (await api.get(`/erinnerungen/kunde/${kundeId}`)).data,

  create: async (req: ErinnerungRequest): Promise<Erinnerung> =>
    (await api.post('/erinnerungen', req)).data,

  update: async (id: number, req: ErinnerungRequest): Promise<Erinnerung> =>
    (await api.put(`/erinnerungen/${id}`, req)).data,

  delete: async (id: number): Promise<void> => {
    await api.delete(`/erinnerungen/${id}`);
  },

  markAsErledigt: async (id: number): Promise<void> => {
    await api.put(`/erinnerungen/${id}/erledigt`);
  },
};

export default erinnerungService;
